const getLessonsData = (sfccModule, lessonRefs) => {
    if (!lessonRefs) return []

    const sfccLessons = sfccModule?.lessons || []
    let firstIncompleteLessonID = null
    let allLessonsComplete = true

    const lessons = lessonRefs.map((lessonRef) => {
        const lessonData = lessonRef?.lesson?.value?.data || {}
        const {id, title, content} = lessonData
        const complete = sfccLessons.some(
            (sfccLesson) => sfccLesson.id && id && sfccLesson.id === id
        )

        if (!complete) {
            allLessonsComplete = false
        }

        if (!complete && !firstIncompleteLessonID) {
            firstIncompleteLessonID = id
        }

        const lesson = {
            id,
            title,
            content,
            complete
        }

        return lesson
    })

    const shouldQuizButtonBeEnabled = (() => {
        if (lessons.length < 2) return false // must have at least 2 lessons
        let shouldQuizEnable = false
        const completedLessons = lessons.filter((l) => l.complete)
        const lastLesson = lessons[lessons.length - 1]
        if (
            completedLessons.length === lessons.length ||
            (completedLessons.length === lessons.length - 1 && lastLesson && !lastLesson.complete)
        ) {
            shouldQuizEnable = true
        }
        return shouldQuizEnable
    })()

    return {
        lessons,
        firstIncompleteLessonID,
        allLessonsComplete,
        shouldQuizButtonBeEnabled
    }
}

const getQuiz = (sfccModule, quizRef) => {
    if (!quizRef) return null

    const sfccQuiz = sfccModule?.quiz || {}
    const quizData = quizRef?.value?.data || {}
    const quiz = {id: quizData?.id, complete: !!sfccQuiz.complete}

    let questions = quizData?.questions || []

    if (questions.length > 0) {
        questions = questions.map((question) => {
            let correctAnswerIndex = 0
            const answers = question.answers.map((answer, i) => {
                if (answer.isCorrect) {
                    correctAnswerIndex = i
                }

                return answer.answer
            })

            return {
                question: question.question,
                answers: answers,
                correctAnswerIndex: correctAnswerIndex
            }
        })
    }

    quiz.questions = questions

    return quiz
}

const getModuleTitle = (moduleData) => {
    if (!moduleData) return ''

    const splittedID = moduleData.id.split('-')
    const moduleNumber = splittedID[splittedID.length - 1]

    return `Module ${moduleNumber}: ${moduleData.title}`
}

const createModule = (moduleData, sfccModule) => {
    const data = moduleData.data
    const lessonsData = getLessonsData(sfccModule, data?.lessons)

    return {
        contentID: moduleData.id,
        id: data?.id || '',
        title: getModuleTitle(data),
        image: data?.image || '',
        lessons: lessonsData.lessons,
        firstIncompleteLessonID: lessonsData.firstIncompleteLessonID,
        allLessonsComplete: lessonsData.allLessonsComplete,
        quiz: getQuiz(sfccModule, data?.quiz),
        summary: data?.summary || null,
        complete: sfccModule?.complete ? true : false,
        shouldQuizButtonBeEnabled: lessonsData.shouldQuizButtonBeEnabled
    }
}

export default createModule
